import { AnimationEffect, SHOW_QA_HOST } from '~/constants';
import { action, observable } from 'mobx';
import moment from 'moment-timezone';

class AnimationEffectStore {
  @observable effectType = AnimationEffect.CherryBlossom;
  @observable show = false;

  private timerId: number | null = null;

  get isDateRange() {
    // 매년 3월 5일 ~ 4월 25일
    const now = moment();
    const year = now.format('YYYY');
    return now.isBetween(`${year}-03-05`, `${year}-04-25`) || SHOW_QA_HOST.includes(window.location.host);
  }

  @action
  setEffectType = (effectType: AnimationEffect) => {
    this.effectType = effectType;
  };

  @action
  setShow = (show: boolean) => {
    this.show = show;
  };

  @action
  runAnimation = (effectType: AnimationEffect) => {
    this.setEffectType(effectType);
    this.show || this.setShow(true);
    clearTimeout(this.timerId);
    this.timerId = window.setTimeout(() => this.setShow(false), 1000 * 10);
  };
}

export default AnimationEffectStore;

export const animationEffectStore = new AnimationEffectStore();
